import { render, staticRenderFns } from "./VerticalCard.vue?vue&type=template&id=42e29a2d&scoped=true&"
import script from "./VerticalCard.vue?vue&type=script&lang=js&"
export * from "./VerticalCard.vue?vue&type=script&lang=js&"
import style0 from "./VerticalCard.vue?vue&type=style&index=0&id=42e29a2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e29a2d",
  null
  
)

export default component.exports